module.exports = __webpack_public_path__ + "img/Camera7.ce035a9f.png";